module.exports = __webpack_public_path__ + "static/background-home-9a291d45fc6825c5e83e5e39c0503b19.jpg";